import React, { useContext, useEffect, useRef, useState } from "react";
import { Tabs, Tab, Modal, Button } from "react-bootstrap";
import { FaUser, FaClipboardList, FaUserCog } from "react-icons/fa"; // Import ikon dari react-icons
import SimpleBar from "simplebar-react";
import CryptoJS from "crypto-js";
import storage from "../../../services/storage";
import { LiveChatContext } from "../../../provider/liveChatContext";
import Ava3 from "../../../assets/img/avatars/avatar-3.jpg";
import ProfileImg from "../../../assets/avatar-broken.png";
import moment from "moment";
import MarkdownRenderer from "../../chat/component/markdownRenderer";
import { throttle } from "lodash";
import { API_URL, API_URL_PAYMENT } from "../../../utilities/url";
import axios from "axios";
import { Link } from "react-router-dom";
import ModalAssistantSetting from "../../../components/modalAssistantSetting";
import authHeader from "../../../services/auth.header";
import authService from "../../../services/auth.service";

const RightComponent = ({
  dataMessage,
  setDataMessage,
  messageText,
  setMessageText,
  selectedSession,
  contactSupervisor,
  setContactSupervisor,
}) => {
  const simpleBarRef = useRef(null);
  const {
    newMessageAssistant,
    setNewMessageAssistant,
    sendDataAssistantMessage,
  } = useContext(LiveChatContext);
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const dt_user = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [hasMore, setHasMore] = useState(true);
  const [scrollTopBeforeLoad, setScrollTopBeforeLoad] = useState(0); // Simpan posisi scroll sebelum memuat data
  const [contentHeightBeforeLoad, setContentHeightBeforeLoad] = useState(0);
  const [activeTab, setActiveTab] = useState("assistant"); // Tab aktif

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  useEffect(() => {
    const scrollElement = simpleBarRef.current?.getScrollElement();
    if (scrollElement) {
      const newContentHeight = scrollElement.scrollHeight;

      // Hitung delta dari tinggi konten sebelum dan sesudah data baru dimuat
      const scrollDelta = newContentHeight - contentHeightBeforeLoad;

      // Set posisi scroll berdasarkan delta
      scrollElement.scrollTop = scrollTopBeforeLoad + scrollDelta;

      // Reset nilai setelah proses selesai
      setContentHeightBeforeLoad(newContentHeight);
    }
  }, [dataMessage]);

  useEffect(() => {
    // Scroll ke bawah hanya saat pemuatan awal
    const scrollElement = simpleBarRef.current?.getScrollElement();
    if (scrollElement) {
      scrollElement.scrollTop = scrollElement.scrollHeight;
    }
  }, [newMessageAssistant]);

  const loadMoreMessages = async () => {
    if (!hasMore) return; // Jika loading atau tidak ada lagi pesan, hentikan

    // Simpan posisi scroll dan tinggi konten sebelum memuat data
    const scrollElement = simpleBarRef.current?.getScrollElement();
    if (scrollElement) {
      setScrollTopBeforeLoad(scrollElement.scrollTop);
      setContentHeightBeforeLoad(scrollElement.scrollHeight);
    }

    // Ambil pesan lebih banyak
    if (dataMessage.length > 0 && dataMessage[0]?.ts_created) {
      const t = dataMessage[0]?.ts_created;
      const timestamp = Math.floor(new Date(t) / 1000);
      axios
        .get(API_URL_PAYMENT + "livechat/assistant/session", {
          params: {
            count: 30,
            ts_until: timestamp,
            // idt_user_assistant: contactSupervisor.idt_user_assistant,
            session_fromto_id: selectedSession.FromToID,
          },
          headers: {
            "X-User-ID": dt_user.idt_user,
            "X-Workspace-ID": workspace.idt_user_workspace,
          },
        })
        .then((response) => {
          if (response.data.data.messages) {
            const sortedMessages = response.data.data.messages.sort(
              (a, b) => new Date(a.ts_created) - new Date(b.ts_created)
            );
            setDataMessage((prevMessages) => [
              ...sortedMessages,
              ...prevMessages,
            ]);
          } else {
            setHasMore(false);
          }
        })
        .catch((error) => {
          if (error.response.data.message) {
            authService.logout();
          }
        });
    }
  };

  const throttledLoadMoreMessages = throttle(loadMoreMessages, 1000);
  useEffect(() => {
    const handleScroll = () => {
      if (simpleBarRef.current) {
        const scrollElement = simpleBarRef.current.getScrollElement();
        const { scrollTop } = scrollElement;

        // Jika scrollTop mendekati 80px dari atas dan masih ada data untuk dimuat
        if (scrollTop <= 80 && hasMore) {
          throttledLoadMoreMessages();
        }
      }
    };

    const scrollElement = simpleBarRef.current?.getScrollElement();
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
      throttledLoadMoreMessages.cancel(); // Hentikan throttle saat komponen di-unmount
    };
  }, [hasMore, dataMessage]);

  const renderMessages = () => {
    const renderedMessages = [];
    let previousDatestamp = null;

    if (dataMessage.length > 0) {
      dataMessage.forEach((message, index) => {
        const currentDatestamp = moment(message.ts_created).isSame(
          moment(),
          "day"
        )
          ? "Today"
          : moment(message.ts_created).format("MMMM D, YYYY");

        // Sisipkan elemen tanggal jika berbeda dengan tanggal sebelumnya
        if (currentDatestamp !== previousDatestamp) {
          renderedMessages.push(
            <div
              key={`datestamp-${index}`}
              className="datestamp text-center my-3 pe-none"
            >
              {currentDatestamp}
            </div>
          );
          previousDatestamp = currentDatestamp;
        }

        // Cek Media URL
        let mediaUrl = "";
        if (message.media_type === "image") {
          if (typeof message.media_url === "string" && message.media_url) {
            mediaUrl = message.media_url;
          } else if (
            typeof message.media_url === "object" &&
            message.media_url !== null
          ) {
            mediaUrl = message.media_url.String || "";
          }
        }

        // Tambahkan pesan ke dalam daftar pesan yang akan dirender
        renderedMessages.push(
          <div
            className={
              message.direction === "in"
                ? "chat-message-right pb-4"
                : "chat-message-left pb-4"
            }
            key={`message-${index}`}
          >
            <div>
              {message.direction === "in" ? (
                <img
                  src={message.avatar || ProfileImg}
                  className="rounded-circle border border-1 me-1"
                  alt={message.name || "User"}
                  width="40"
                  height="40"
                />
              ) : (
                <img
                  src={
                    message.avatar || contactSupervisor.profile_pic
                      ? contactSupervisor.profile_pic
                      : ProfileImg
                  }
                  className="rounded-circle me-1"
                  alt={message.name || "User"}
                  width="40"
                  height="40"
                />
              )}

              <div className="text-muted small text-center text-nowrap mt-2">
                {moment(message.ts_created).format("HH:mm")}
              </div>
            </div>
            <div
              className={
                message.direction === "in"
                  ? "flex-shrink-1 bg-left-chat-message rounded py-2 px-3 me-3"
                  : "flex-shrink-1 bg-right-chat-message rounded py-2 px-3 ms-3"
              }
            >
              <div
                className={
                  message.direction === "in"
                    ? "fw-bold mb-1 text-end"
                    : "fw-bold mb-1"
                }
              >
                {/* {message.direction == "in"
                  ? message.name
                    ? message.name
                    : message.fromto_id
                  : "Bot"} */}
              </div>
              {mediaUrl && (
                <img
                  src={mediaUrl}
                  alt="Media"
                  className="img-fluid rounded mb-2"
                />
              )}
              <div className="markdown">
                <MarkdownRenderer markdown={message.content || ""} />
              </div>
            </div>
          </div>
        );
      });
    }

    return renderedMessages;
  };

  const templateData = [
    { id: 1, name: "Template 1" },
    { id: 2, name: "Template 2" },
  ];

  const handleMessageText = (event) => {
    setMessageText(event.target.value);
  };

  const handleClearMessage = () => {
    axios
      .post(
        API_URL + "clear-livechat-message-assistant",
        {
          idt_user_workspace: workspace.idt_user_workspace,
          // idt_user_assistant: contactSupervisor.idt_user_assistant,
          session_from_to: selectedSession.FromToID,
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          setDataMessage([]);
        }
        setConfirmModal(false);
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const handleSendMessage = () => {
    const payload = {
      module: "livechat_assistant",
      data: {
        user_id: dt_user.idt_user,
        workspace_id: workspace.idt_user_workspace,
        device_id: selectedSession.IDTDevice,
        direction: "in",
        media_id: null,
        media_type: "text",
        media_url: null,
        session_fromto_id: selectedSession.FromToID,
        content: messageText,
        reference_id: null,
      },
    };
    if (messageText || messageText !== "") {
      sendDataAssistantMessage(payload);
      setNewMessageAssistant(true);
      const params = {
        idt_message_assistant: null,
        ts_created: moment().format("YYYY-MM-DD HH:mm:ss"),
        idt_user: dt_user.idt_user,
        idt_user_workspace: workspace.idt_user_workspace,
        idt_user_assistant: {
          Int32: 0,
          Valid: false,
        },
        module: "livechat_assistant",
        session_fromto_id: {
          String: dataMessage.length > 0 ? selectedSession.FromToID : null,
          Valid: true,
        },
        idt_osa_session: {
          Int32: 0,
          Valid: true,
        },
        content: messageText,
        media_type: "text",
        media_id: {
          String: "",
          Valid: true,
        },
        media_url: {
          String: "",
          Valid: true,
        },
        direction: "in",
      };
      setDataMessage((prevMessages) => [...prevMessages, params]);
    }
    // console.log(JSON.stringify(payload));
  };

  return (
    <div className="container">
      {/* Tab Navigation */}
      <ul className="nav nav-tabs d-flex justify-content-between">
        <li className="nav-item flex-grow-1 text-center">
          <a
            className={`nav-link ${activeTab === "assistant" ? "active" : ""}`}
            onClick={() => setActiveTab("assistant")}
          >
            <FaUser className="mt-1 mb-1" size={20} /> <br /> Assistant
          </a>
        </li>
        {/* <li className="nav-item flex-grow-1 text-center">
          <a
            className={`nav-link ${activeTab === "template" ? "active" : ""}`}
            onClick={() => setActiveTab("template")}
          >
            <FaClipboardList className="mt-1 mb-1" size={20} /> <br /> Template
          </a>
        </li> */}
        <li className="nav-item flex-grow-1 text-center">
          <a className="nav-link" onClick={() => setShowModal(true)}>
            <FaUserCog className="mt-1 mb-1" size={20} /> <br /> Setting
          </a>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content">
        {/* Tab Assistant */}
        {activeTab === "assistant" && (
          <div className="tab-pane fade show active">
            <div className="position-relative">
              {contactSupervisor ? (
                selectedSession ? (
                  <SimpleBar
                    className="chat-messages bg-light-grey px-3"
                    style={{ overflowX: "hidden", marginRight: "1px" }}
                  >
                    {dataMessage.length <= 0 && (
                      <div className="chat-message-left mt-3 pb-4">
                        <div>
                          <img
                            src={
                              contactSupervisor.profile_pic
                                ? contactSupervisor.profile_pic
                                : ProfileImg
                            }
                            class="rounded-circle me-1"
                            alt="User"
                            width="40"
                            height="40"
                          />
                          <div className="text-muted small text-center text-nowrap mt-2">
                            {moment().format("HH:mm")}
                          </div>
                        </div>
                        <div className="flex-shrink-1 bg-right-chat-message rounded py-2 px-3 ms-3">
                          <div className="fw-bold text-black mb-1 text-start">
                            Bot
                          </div>
                          <div className="markdown">
                            <p className="text-black">
                              Hey! What do you want to know about this customer?
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {renderMessages()}
                  </SimpleBar>
                ) : null
              ) : null}
            </div>

            <div className="flex-grow-0 py-3 px-4 border-top">
              {contactSupervisor ? (
                selectedSession ? (
                  <div className="input-group">
                    <input type="file" id="file-upload" className="d-none" />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type your message"
                      value={messageText}
                      onChange={handleMessageText}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}
                    />
                    <button
                      className="btn btn-success"
                      onClick={() => handleSendMessage()}
                    >
                      Send
                    </button>
                    {dataMessage.length > 0 && (
                      <button
                        className="btn btn-danger ms-2"
                        onClick={() => setConfirmModal(true)}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="text-center text-dark fw-bold mt-2">
                    Click a chat session to start chatting with me to get more
                    insight about the conversation session with your customer.
                  </div>
                )
              ) : (
                <div className="text-center fw-bold mt-2">
                  <Link to="#" onClick={() => setShowModal(true)}>
                    Set up your AI Conversation Analyzer Agent, to get more
                    insight about the conversation with your customer.
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tab Template */}
        {/* {activeTab === "template" && (
          <div className="tab-pane fade show active">
            <div className="position-relative">
              {contactSupervisor ? (
                <SimpleBar className="chat-messages p-2">
                  <div className="px-4">
                    {templateData.map((item) => (
                      <div
                        className="card mb-3 bg-dark c-pointer"
                        key={item.id}
                        onClick={() => alert(item.name)}
                      >
                        <div className="card-body p-2">
                          <p className="mb-0 text-white fs-12">{item.name}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </SimpleBar>
              ) : null}
            </div>

            <div className="flex-grow-0 py-3 px-4 border-top bg-white">
              {contactSupervisor ? (
                selectedSession ? (
                  <div className="input-group">
                    <input type="file" id="file-upload" className="d-none" />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type your message"
                      value={messageText}
                      onChange={handleMessageText}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}
                    />
                    <button
                      className="btn btn-success"
                      onClick={() => handleSendMessage()}
                    >
                      Send
                    </button>
                  </div>
                ) : null
              ) : (
                <div className="text-center fw-bold mt-2">
                  <Link to="#" onClick={() => setShowModal(true)}>
                    Set up your AI Conversation Analyzer Agent, to get more
                    insight about the conversation with your customer.
                  </Link>
                </div>
              )}
            </div>
          </div>
        )} */}
      </div>
      {/* Modal Assistant */}
      <ModalAssistantSetting
        show={showModal}
        handleClose={() => setShowModal(false)}
        contactSupervisor={contactSupervisor}
        setContactSupervisor={setContactSupervisor}
        FromToID={selectedSession?.FromToID}
      />
      {/* Modal Confirmation */}
      <Modal
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to clear all these messages?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleClearMessage}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RightComponent;
